/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-study-dashboard.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import { DashboardType } from 'types/graphql-global-types';
import AdminDashboard from 'views/pages/admin/study/admin-dashboard';

const AdminSiteDashboard = ({ study }: any) => <AdminDashboard study={study} type={DashboardType.STUDY} />;

export default AdminSiteDashboard;
